module.exports = "https://static.wmbcdn.com/uniweb/images/ba634ec94671dff97c2e0a5d657af9a1.svg";